import React from "react";
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell } from "recharts";

const TalentAuditionOverviewChart = ({
  dashboardData,
  isMobile,
  COLOR_MAP
}) => {
  const currentInnerRadius = isMobile ? 58 : 66;
  const currentOuterRadius = isMobile ? 84 : 96;
  const pieChartData = (dashboardData?.chartData || []).filter(item => item.name.toLowerCase() !== "total");
  const totalAppliedCount = dashboardData?.kpis?.totalApplications || 0;

  return (
    <div className="td-card td-chart-card d-flex flex-column justify-content-between h-100">
      <div className="card-header pb-1 mb-2 border-0 bg-transparent">
        <h2 style={{ fontSize: "1.15rem", fontWeight: 700, margin: 0 }}>Audition Overview</h2>
      </div>
      <div className="chart-container pie-chart-wrapper flex-grow-1" style={{ position: "relative", width: "100%", minHeight: "240px", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <ResponsiveContainer width="100%" height={240}>
          <PieChart>
            <Tooltip content={({ active, payload }) => {
              if (active && payload && payload.length) {
                const data = payload[0];
                return (
                  <div className="custom-pie-tooltip">
                    <div className="tooltip-header">
                      <span className="tooltip-dot" style={{ backgroundColor: COLOR_MAP[data.name] || "#3b82f6" }}></span>
                      <p className="tooltip-title">{data.name}</p>
                    </div>
                    <p className="tooltip-value">Count: <span>{data.value}</span></p>
                  </div>
                );
              }
              return null;
            }} />
            <Pie data={pieChartData} cx="50%" cy="50%" innerRadius={currentInnerRadius} outerRadius={currentOuterRadius} paddingAngle={4} dataKey="applications" cornerRadius={5} stroke="none">
              {pieChartData.map((entry, index) => (<Cell key={`cell-${index}`} fill={COLOR_MAP[entry.name] || "#3b82f6"} />))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="pie-center-text">
          <span className="pie-center-value" style={{ fontSize: "26px" }}>{totalAppliedCount}</span>
          <span className="pie-center-label" style={{ fontSize: "12px" }}>Total</span>
        </div>
      </div>
      <div className="td-chart-stats justify-content-center mt-2">
        <div className="td-chart-stat-item"><span className="td-chart-dot shortlisted"></span><p>Shortlisted</p></div>
        <div className="td-chart-stat-item"><span className="td-chart-dot pending"></span><p>Pending</p></div>
        <div className="td-chart-stat-item"><span className="td-chart-dot rejected"></span><p>Rejected</p></div>
      </div>
    </div>
  );
};

export default TalentAuditionOverviewChart;
